import '../../../js/core.js'
import 'sticky-kit/dist/sticky-kit'
import '../../../js/sticky-sidebar.js'
import Collapse from "bootstrap/js/src/collapse";
import '../../../js/collapse.js'
import './page-crops-management-single.less';

$(function () {
    import('owl.carousel/src/js/owl.carousel').then(() => {
        import('owl.carousel/src/js/owl.navigation').then(() => {
            import('owl.carousel/src/js/owl.lazyload').then(() => {
                jQuery('.js-articles-carousel').owlCarousel({
                    responsive: {
                        0: {
                            items: 1,
                        },
                        980: {
                            items: 2,
                        },
                        1240: {
                            items: 3,
                        },
                    },
                    nav: true,
                    loop: true,
                    dots: true,
                    margin: 20,
                    slideBy: 1
                });
            });
        });
    })
});